<template>
  <myTable :categoryName="'类型'" :isShowNo="true" :type="4"> </myTable>
</template>

<script>
// import {
//   SaveAssets,
//   RemoveAssetss,
//   GetAssetsBylevelType
// } from '@/api'
import myTable from '@/views/components/secondCategoryTable'
export default {
  components: {
    myTable
  },
  data () {
    return {
      // SaveAssets: SaveAssets,
      // RemoveAssetss: RemoveAssetss,
      // GetAssetsBylevelType: GetAssetsBylevelType
    }
  }
};
</script>
